import styled from 'styled-components';

export const StyledShimmerWrapper = styled.div`
  width: 100%;
`;

export const StyledButtonWrapper = styled.div`
  margin: ${({ theme }) => `${theme.space[4]}px ${theme.space[4]}px ${theme.space[10]}px`};
`;

export const StyledDeliveryInfoUpdatedContainer = styled.div`
  margin: ${({ theme }) => `${theme.space[4]}px ${theme.space[4]}px ${theme.space[0]}px ${theme.space[4]}px`};
`;
